<script>
import appConfig from "@/app.config";
import { Modal } from "bootstrap";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      // global data
      branch_id: null,
      disposed_asset: {},
      add_modal: null,
      dispose_modal: null,
      remaining_value: 0,
      branches: [],
      branch_sites: [],
      newAsset: {
        acquisition_method: "agent",
      },
      registerAsset: {},
      // end global data
      fixedAssets: [],
      typesOptions: [],
      cashAccounts: [],
      addAsset: [{}],
      page: 1,
      limit: 20,
      tot_pages: 0,

      classes: [],
      subclasses: [],
      SearchMode: false,
      search: "",
      agents: [],
      donators: [],
      isOnCredit: true,
      selectedPaymentType: "",
      paymentTypes: [
        { id: 1, name: "مديونية", name_en: "Pay On Credit" },
        { id: 2, name: "دفع جزئي", name_en: "Partial Payment" },
        { id: 3, name: "دفع كامل", name_en: "Full Payment" },
      ],
      due_date: null,
      is_du_time: false,
      previous_payable: 0,
      prepayment: 0,
      dropdown: null,
      filter: "all",

      add_custody_modal: {},
      transfer_hr_custody_modal: {},
      emps: [],
      hr_custody: {},
      fixed_asset_disposal_types: [],
      disposal_type_code: {},
      reference_no: null,
      company_branches: [],
      edit_modal: {},
      data: {},
      loadingExcel: false,
      // appprices:[]
    };
  },
  computed: {
    totalDisposalAccountsValue() {
      return this.addAsset
        .filter((account) => account.cash_account && account.value)
        .reduce((sum, account) => sum + account.value, 0);
    },
    validateFullPayment() {
      return this.newAsset?.agent && this.newAsset?.agent?.id
        ? this.selectedPaymentType < 3 ||
            this.totalAddPayAccounts >=
              parseFloat(this.newAsset?.initial_book_value)
        : this.newAsset?.donator && this.newAsset?.donator?.id
        ? this.newAsset.initial_book_value
        : false;
    },
    validateDonatorStep() {
      return this.newAsset?.donator &&
        this.newAsset?.donator.id &&
        this.newAsset.initial_book_value
        ? true
        : false;
    },
    totalAddPayAccounts() {
      return this.addAsset
        .filter((account) => account.value)
        .reduce((sum, account) => {
          sum += parseFloat(account.value);
          console.log("sum", sum, "account", account);

          return sum;
        }, 0);
    },
  },
  methods: {
    agentSearch(search) {
      this.http
        .post("agents/search", {
          search,
        })
        .then((res) => {
          if (res.status) {
            this.agents = res.data;
            console.log("step 113 :", this.agents);
          }
        });
    },
    selectAgent(agent) {
      this.newAsset.agent_id = agent.id;
      this.http
        .post("agents/select-supplier", {
          id: agent.id,
        })
        .then((res) => {
          if (res.status) {
            this.prepayment = res.data.prepayment;
            this.previous_payable = res.data.previous_payable;
            // if the functional currency is the supplier currency make it selected
          }
        });
    },
    showAgentLabel(one) {
      return this.$i18n.locale == "en"
        ? one.code + "-" + one.name_en
        : one.code + "-" + one.name;
    },
    donatorSearch(search) {
      this.http
        .post("donators/search", {
          search,
          page: 1,
          limit: 20,
        })
        .then((res) => {
          if (res.status) {
            this.donators = res.data;
          }
        });
    },
    selectDonator(donator) {
      this.newAsset.donator_id = donator.id;
    },
    showDonatorLabel(one) {
      console.log("step 139 :", one);

      return this.$i18n.locale == "en" ? one.name_en : one.name;
    },
    searchFixedAssets(page) {
      if (!this.search.length > 0) this.cancelFixedAssetsSearchMode();
      this.SearchMode = true;
      this.http
        .post("fixed-assets/search", {
          page,
          limit: this.limit,
          search: this.search,
          filter: this.filter,
        })
        .then((res) => {
          this.fixedAssets = res.data;
          (this.page = page),
            (this.tot_pages = Math.ceil(res.tot / this.limit));
        });
    },
    cancelFixedAssetsSearchMode() {
      this.search = "";
      this.SearchMode = false;
      this.getFixedAssetsPagination(this.page);
    },

    addFixedAsset() {
      this.typesOptions.forEach((type) => {
        if (type.id == this.newAsset.fixed_asset_type_id) {
          this.newAsset.type_name = type.name_en;
        }
      });
      console.log(
        "this.newAsset",
        this.newAsset,
        "this.addAsset",
        this.addAsset
      );

      this.http
        .post("fixed-assets", {
          newAsset: this.newAsset,
        })
        .then((res) => {
          if (res.status) {
            this.newAsset = {};
            this.getFixedAssetsPagination(this.page);
            this.add_modal.hide();
          }
        });
    },
    preEditFixedAsset(fixedAsset) {
      this.edit_modal.show();
      this.newAsset = JSON.parse(JSON.stringify(fixedAsset));
      this.newAsset.depreciable = this.newAsset.depreciable ? true : false;
      this.getFixedAssetSubClasses(fixedAsset.fixed_asset_class_id);
    },
    preAddAsset() {
      this.getAccounts();
      this.reference_no = null;
      this.add_modal.show();
    },
    editFixedAsset() {
      this.http
        .put("fixed-assets", this.newAsset.id, this.newAsset)
        .then((res) => {
          if (res.status) {
            this.edit_modal.hide();

            this.getFixedAssetsPagination(this.page);
          }
        });
    },
    deleteFixedAsset(fixedAsset) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("fixed-assets", fixedAsset.id).then(() => {
            this.getFixedAssetsPagination(this.page);
          });
        }
      });
    },
    getFixedAssetsPagination(page) {
      this.http
        .post("fixed-assets/pagination", {
          limit: this.limit,
          page: page,
          filter: this.filter,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          console.log(this.tot_pages);
          this.fixedAssets = res.data;
          console.log("this.fixedAssets", this.fixedAssets);
        });
    },
    getAccounts() {
      this.http.post("transactions/cash-accounts", {}).then((resp) => {
        this.cashAccounts = resp.data;
      });
    },
    doDispose() {
      this.http
        .post("fixed-assets/disposal", {
          id: this.disposed_asset.id,
          remaining_value: this.remaining_value,
          fixed_asset_type_id: this.disposed_asset.fixed_asset_type_id,
          name: this.disposed_asset.name,
          name_en: this.disposed_asset.name_en,
          accounts: this.addAsset,
          disposal_type_code: this.disposal_type_code,
        })
        .then((res) => {
          if (res.status) {
            this.dispose_modal.hide();
            this.getFixedAssetsPagination(this.page);
          }
        });
    },
    transferAsset(asset) {
      let locale = this.$i18n.locale;
      let self = this;
      this.http
        .post("branches/execlude", { asset_branch_id: asset.branch_id })
        .then((res) => {
          this.branches = res.data;
          var data = {
            title: "fixed_assets.transfer",
            inputs: [
              {
                model: "to_branch_id",
                type: "select",
                options: (() => {
                  return this.branches.map((data) => {
                    return {
                      value: data.id,
                      label: locale == "ar" ? data.name : data.name_en,
                    };
                  });
                })(),
                label: "fixed_assets.transfer_to",
              },
            ],
            buttons: [
              {
                text: "fixed_assets.transfer",
                closer: true,
                color: "primary",
                handler: (obj) => {
                  obj.from_branch_id = asset.branch_id;
                  this.http
                    .put("fixed-assets/transfer", asset.id, obj)
                    .then((res) => {
                      self.branches = res.data;
                      self.getFixedAssetsPagination(self.page);
                    });
                },
              },
              {
                text: "Cancel",
                closer: true,
                color: "danger",
                handler: () => {
                  console.log("Like Clicked");
                },
              },
            ],
          };
          this.popup.modal(data);
        });
    },
    getFixedAssetTypesOptions() {
      this.http.get("fixed-assets/types").then((resp) => {
        this.typesOptions = resp.data;
      });
    },
    sellFixedAsset(asset) {
      this.disposed_asset = asset;
      this.http
        .post("fixed-assets/process-disposal", { id: asset.id })
        .then((res) => {
          console.log(res.status);
          this.remaining_value = res.data[0]?.remaining_value;
          this.addAsset = [{}];
          this.getAccounts();
          this.dispose_modal.show();
        });
    },
    getBranchSites(branch_id) {
      this.newAsset.branch_site_id = null;
      this.http
        .post("level-one-chart-of-accounts/get-branch-sites", { branch_id })
        .then((resp) => {
          console.log(resp.data);
          this.branch_sites = resp.data;
        });
    },
    getFixedAssetsClasses() {
      this.http.get("fixed-assets/classes").then((res) => {
        this.classes = res.data;
      });
    },
    getFixedAssetSubClasses(id) {
      this.http.get("fixed-assets/subclasses/" + id).then((res) => {
        this.subclasses = res.data;
      });
    },
    exportExcel() {
      this.loadingExcel = true;
      this.http
        .download(
          "level-one-chart-of-accounts/assets/download",
          `Fixed Assets.xlsx`,
          {
            branch_id: this.branch_id,
          }
        )
        .then(() => {
          this.loadingExcel = false;
        });
    },

    startPaymentProcess() {
      if (this.selectedPaymentType == 1) {
        this.isOnCredit = true;
        this.addAsset = [{}];
      } else {
        this.isOnCredit = false;
      }
      if (this.selectedPaymentType > 2) {
        this.is_du_time = true;
      } else {
        this.is_du_time = false;
      }
    },

    openTransferHrCustodyModal(data) {
      this.hr_custody = JSON.parse(JSON.stringify(data));
      this.transfer_hr_custody_modal.show();
    },
    searchEmployees(search) {
      this.http
        .post(
          "emp-custodies/search-emps",
          {
            search,
            limit: 25,
            current_emp_id: this.hr_custody.under_custody[0]?.emp_id,
          },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.emps = res.data;
          }
        });
    },
    showEmpLabel(one) {
      return one.name;
    },

    addHrCustody() {
      this.http
        .post("emp-custodies", {
          fixed_asset_id: this.hr_custody?.fixed_asset?.id,
          emp_id: this.hr_custody?.emp?.id,
          reference_no: this.hr_custody.reference_no,
        })
        .then((res) => {
          if (res.status) {
            this.add_custody_modal.hide();
            this.getFixedAssetsPagination(this.page);
            this.hr;
          }
        });
    },
    searchFixedAssetsForCustody(search) {
      console.log("product :", this.product);

      this.http
        .post("emp-custodies/search-fixed-assets", { search }, null, true)
        .then((res) => {
          if (res.status) {
            this.fixed_assets = res.data;
          }
        });
    },
    showLabel(one) {
      return this.$i18n.locale == "en" ? one?.name_en : one?.name;
    },
    getFixedAssetDisposalTypes() {
      this.http.get("fixed-asset-disposal-types").then((res) => {
        if (res.status) this.fixed_asset_disposal_types = res.data;
        if (this.fixed_asset_disposal_types.length)
          this.disposal_type_code = this.fixed_asset_disposal_types[0].code;
      });
    },
    getBranches() {
      this.http.get("branches").then((res) => {
        if (res.status) this.company_branches = res.data;
      });
    },
  },
  mounted() {
    this.selectedPaymentType = this.paymentTypes[0]?.id;
    const current_user = JSON.parse(localStorage.currentUser);
    this.branch_id = current_user.branch_id;
    this.getFixedAssetsPagination(1);
    this.getFixedAssetTypesOptions();
    this.getFixedAssetsClasses();
    this.getBranchSites();
    this.getAccounts();
    this.getBranches();
    // this.getFixedAssetDisposalTypes();

    this.add_modal = new Modal("#addModal");
    this.edit_modal = new Modal("#editModal");
  },
};
</script>

<template>
  <div :dir="$i18n.locale == 'ar' ? 'ltr' : 'ltr'">
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @input="searchFixedAssets(page)"
                    type="text"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="search"
                    style="
                      background-color: #2a3042 !important;
                      wdith: 250px !important;
                    "
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                </div>
              </div>
            </div>
            <div
              class="col-6 d-flex justify-content-end align-items-center"
              style="gap: 15px"
            >
              <button
                type="button"
                :disabled="loadingExcel"
                class="btn btn-success float-end mb-4"
                @click="exportExcel()"
              >
                <div
                  :class="loadingExcel ? 'd-block' : 'd-none'"
                  style="width: 100%; font-size: 5px; padding: 0 20px"
                >
                  <span
                    class="bx bx-loader-alt fa-spin fa-4x"
                    style="color: #289091"
                  ></span>
                </div>
                <span :class="loadingExcel ? 'd-none' : 'd-block'">
                  {{ $t("fixed_assets.excel") }}
                </span>
              </button>

              <button
                type="button"
                @click="preAddAsset()"
                class="btn btn-primary float-end mb-4"
              >
                {{ $t("fixed_assets.add_fixed_asset") }}
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>

                  <th scope="col">{{ $t("fixed_assets.label") }}</th>
                  <th scope="col">{{ $t("fixed_assets.label_en") }}</th>

                  <!-- <th scope="col">{{ $t("fixed_assets.supplier") }}</th>
                  <th scope="col">{{ $t("fixed_assets.donator") }}</th> -->
                  <th scope="col">{{ $t("fixed_assets.type") }}</th>

                  <th scope="col">{{ $t("fixed_assets.main_class") }}</th>
                  <th scope="col">{{ $t("fixed_assets.sub_class") }}</th>

                  <th scope="col">
                    {{ $t("fixed_assets.maintenance_rating") }}
                  </th>
                  <th scope="col">{{ $t("fixed_assets.operations") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :title="
                    $i18n.locale == 'ar'
                      ? fixedAsset?.name
                      : fixedAsset?.name_en
                  "
                  v-for="(fixedAsset, index) in fixedAssets"
                  :key="index"
                  class=""
                >
                  <td>{{ (page - 1) * this.limit + index + 1 }}</td>

                  <td>
                    {{ fixedAsset?.name }}
                  </td>
                  <td>
                    {{ fixedAsset?.name_en }}
                  </td>

                  <!-- <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.agent_name
                        : fixedAsset?.agent_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.donator_name
                        : fixedAsset?.donator_name_en
                    }}
                  </td> -->
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.fat_type
                        : fixedAsset?.fat_type_en
                    }}
                  </td>

                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.class_name
                        : fixedAsset?.class_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.subclass_name
                        : fixedAsset?.subclass_name_en
                    }}
                  </td>

                  <td>{{ fixedAsset?.maintenance_rating }}</td>
                  <td>
                    <router-link
                      style="margin-inline-end: 4px"
                      :to="{
                        name: 'fixed-assets-profile',
                        params: { id: fixedAsset?.id },
                      }"
                    >
                      <button
                        class="btn btn-info"
                        role="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="
                          $i18n.locale == 'ar'
                            ? fixedAsset.name
                            : fixedAsset.name_en +
                              ' ' +
                              $t('fixed_assets.profile')
                        "
                      >
                        <i class="bx bxs-detail"></i>
                      </button>
                    </router-link>

                    <a
                      style="margin-inline-end: 4px"
                      class="btn btn-primary btn-md"
                      @click="preEditFixedAsset(fixedAsset)"
                      role="button"
                      >{{ $t("popups.edit") }}</a
                    >
                    <!-- <a
                      class="btn btn-danger btn-md"
                      href="javascript: void(0);"
                      role="button"
                      @click="deleteFixedAsset(fixedAsset)"
                      >{{ $t("popups.delete") }}</a
                    > -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--end-->
    <!--Start Add Modal-->
    <div
      class="modal fade"
      id="addModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="addFixedAsset()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("popups.add") }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{ $t("fixed_assets.type") }}</label>

                    <select
                      required
                      v-model="newAsset.fixed_asset_type_id"
                      class="form-select mb-2"
                      id="account_id"
                      :placeholder="$t('fixed_assets.type')"
                    >
                      <option
                        v-for="options in typesOptions"
                        :key="options"
                        :value="options?.id"
                      >
                        {{
                          $i18n.locale == "ar"
                            ? options?.name
                            : options?.name_en
                        }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.main_class")
                    }}</label>
                    <select
                      required
                      class="form-select"
                      @change="
                        getFixedAssetSubClasses(newAsset.fixed_asset_class_id)
                      "
                      v-model="newAsset.fixed_asset_class_id"
                    >
                      <option :value="cls.id" :key="cls" v-for="cls in classes">
                        {{ $i18n.locale == "en" ? cls.name_en : cls.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center mb-2"
                  v-if="newAsset.fixed_asset_class_id"
                >
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.sub_class")
                    }}</label>
                    <select
                      required
                      class="form-select"
                      v-model="newAsset.asset_subclass_id"
                    >
                      <option
                        :value="cls.id"
                        :key="cls"
                        v-for="cls in subclasses"
                      >
                        {{ $i18n.locale == "en" ? cls.name_en : cls.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{ $t("fixed_assets.label") }}</label>
                    <input
                      required
                      v-model="newAsset.name"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.label')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.label_en")
                    }}</label>
                    <input
                      required
                      v-model="newAsset.name_en"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.label_en')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name")
                    }}</label>
                    <input
                      v-model="newAsset.alt_name"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.alt_name')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name_en")
                    }}</label>
                    <input
                      v-model="newAsset.alt_name_en"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.alt_name_en')"
                    />
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.maintenance_rating")
                    }}</label>
                    <input
                      required
                      v-model="newAsset.maintenance_rating"
                      type="number"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.maintenance_rating')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.add") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End Add Modal-->

    <!--Start register Modal-->

    <!--End register Modal-->

    <!--Start Edit Modal-->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="editFixedAsset()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("popups.edit") }}
              </h5>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="row d-flex align-items-center mb-2"></div>

                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.main_class")
                    }}</label>
                    <select
                      class="form-select"
                      @change="
                        getFixedAssetSubClasses(newAsset.fixed_asset_class_id)
                      "
                      v-model="newAsset.fixed_asset_class_id"
                    >
                      <option :value="cls.id" :key="cls" v-for="cls in classes">
                        {{ $i18n.locale == "en" ? cls.name_en : cls.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center mb-2"
                  v-if="newAsset.fixed_asset_class_id"
                >
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.sub_class")
                    }}</label>
                    <select
                      class="form-select"
                      v-model="newAsset.asset_subclass_id"
                    >
                      <option
                        :value="cls.id"
                        :key="cls"
                        v-for="cls in subclasses"
                      >
                        {{ $i18n.locale == "en" ? cls.name_en : cls.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{ $t("fixed_assets.label") }}</label>
                    <input
                      v-model="newAsset.name"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.label')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.label_en")
                    }}</label>
                    <input
                      v-model="newAsset.name_en"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.label_en')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name")
                    }}</label>
                    <input
                      v-model="newAsset.alt_name"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.alt_name')"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name_en")
                    }}</label>
                    <input
                      v-model="newAsset.alt_name_en"
                      type="text"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.alt_name_en')"
                    />
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.maintenance_rating")
                    }}</label>
                    <input
                      v-model="newAsset.maintenance_rating"
                      type="number"
                      class="form-control mb-2"
                      :placeholder="$t('fixed_assets.maintenance_rating')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.edit") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End Edit Modal-->

    <!-- Dispose Modal -->

    <div
      class="modal fade"
      id="transferHrCustodyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <form @submit.prevent="transferHrCustody()">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t("hr_custodies.search_emps") }}
              </h5>
              <button
                type="button"
                class="close"
                @click="transferHrCustodyModal.hide()"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("hr_custodies.emp_name")
                }}</label>
                <AutoComplete
                  v-model="data.emp"
                  :suggestions="emps"
                  @complete="searchEmployees($event.query)"
                  :complete-on-focus="true"
                  :optionLabel="showEmpLabel"
                  :inputClass="'form-control'"
                  class="w-100"
                />
              </div>
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("fixed_assets.reference_no")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.reference_no"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="this.transfer_hr_custody_modal.hide()"
                class="btn btn-light"
              >
                {{ $t("popups.cancel") }}
              </button>
              <button
                :disabled="!(data?.emp && data?.emp?.id)"
                type="submit"
                class="btn btn-primary"
              >
                {{ $t("popups.transfer") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              this.search
                ? searchFixedAssets(page - 1)
                : getFixedAssetsPagination(page - 1)
            "
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              this.search ? searchFixedAssets(p) : getFixedAssetsPagination(p)
            "
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              this.search
                ? searchFixedAssets(page - 1)
                : getFixedAssetsPagination(page + 1)
            "
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
